import React from 'react'
import { StyledLogo } from './Logo.styled'

export const Logo = (props) => {
  return <StyledLogo {...props} />
}
